export const ERROR_404_BUTTON_V2 = {
  "en": "Return to the homepage",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Return to the homepage",
  "it": "Return to the homepage",
  "ja": "Return to the homepage",
  "ko": "Return to the homepage",
  "nl": "Return to the homepage",
  "pt-pt": "Return to the homepage",
  "sv": "Return to the homepage",
  "zh": "Return to the homepage"
}